import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "mb-2"
};
import { app } from "@/di";
import TerminationFeeCalculator from "@/modules/team/services/TerminationFeeCalculator";
import PlayerContractTerminator from "@/modules/team/services/PlayerContractTerminator";
import SimpleActionSheetItem from "@/modules/vue/components/SimpleActionSheetItem.vue";
import RichDialog from "@/modules/vue/components/RichDialog.vue";
import RichDialogRow from "@/modules/vue/components/RichDialogRow.vue";
import { GateTypeEnum } from "@/modules/action-points/enums";
import { BankCategory } from "@/modules/finances/enums";
export default /*#__PURE__*/_defineComponent({
  __name: 'PlayerContractTerminationActionSheetItem',
  props: {
    player: null
  },
  emits: ['updated'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const terminationPrice = ref(app.get(TerminationFeeCalculator).calculate(props.player));
    const terminateContractConfirmation = ref(null);
    const onClickTerminateContract = () => {
      terminateContractConfirmation.value.confirm().then(async ({
        commit
      }) => {
        await app.get(PlayerContractTerminator).terminate(props.player, terminationPrice.value);
        await commit();
        emit('updated');
      });
    };
    return (_ctx, _cache) => {
      const _component_NAlert = _resolveComponent("NAlert");
      return _openBlock(), _createElementBlock(_Fragment, null, [__props.player.team && __props.player.team.user ? (_openBlock(), _createBlock(SimpleActionSheetItem, {
        key: 0,
        color: _ctx.ColorEnum.Red,
        icon: _ctx.IconEnum.Ban,
        "hide-on-click": "",
        onClick: onClickTerminateContract
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('terminate_contract')), 1)]),
        _: 1
      }, 8, ["color", "icon"])) : _createCommentVNode("", true), _createVNode(RichDialog, {
        ref_key: "terminateContractConfirmation",
        ref: terminateContractConfirmation,
        "show-confirmation-input": "",
        price: terminationPrice.value,
        "gate-type": _unref(GateTypeEnum).BALANCE,
        "gate-value": terminationPrice.value,
        "gate-meta": {
          category: _unref(BankCategory).WAGES,
          label: _ctx.$t('player_contract_termination')
        }
      }, {
        title: _withCtx(() => [_createTextVNode(_toDisplayString(__props.player.shortName), 1)]),
        rows: _withCtx(() => [_createVNode(RichDialogRow, null, {
          label: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('current_contract')), 1)]),
          value: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$duration(__props.player.contractYears, 'years').humanize()), 1)]),
          _: 1
        }), _createVNode(RichDialogRow, null, {
          label: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('wage')), 1)]),
          value: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$moneyPerMonth(__props.player.wage)), 1)]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('are_you_sure_you_want_to_terminate_players_contract?')), 1), _createVNode(_component_NAlert, {
          type: "error"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('the_process_can_not_be_reverted')), 1)]),
          _: 1
        })]),
        _: 1
      }, 8, ["price", "gate-type", "gate-value", "gate-meta"])], 64);
    };
  }
});